import React from 'react';
import UserQualificationComponent from '../../../components/admin/user/UserQualificationComponent';

const UserQualification: React.FC = () => {
  return <UserQualificationComponent />;
};

export default UserQualification;
